import * as React from 'react';
import { connect } from 'react-redux';
import ScrollToTopView from 'scroll-to-top';
import { ICalendarAppState } from '../../redux-state';
import { throttle } from 'lodash';

interface IExternalProps {
}

interface StateToProps {
    appearanceOffset: number;
}

interface IScrollToTopBase {
    scrollToTop: () => void;
}

interface IScrollToTopState {
    showButton: boolean;
}

type ScrollToTopProps = IExternalProps & StateToProps
export type CombinedScrollToTopProps = ScrollToTopProps & IScrollToTopBase & IScrollToTopState;

export class ScrollToTopBase extends React.Component<ScrollToTopProps, IScrollToTopState> implements IScrollToTopBase {
    public showButton = false;

    constructor(props) {
        super(props);
        this.state = {
            showButton: false
        }
    }

    scrollToTop() {
        if (!window.matchMedia('(prefers-reduced-motion: true)').matches) {
            document.getElementById("main").scrollIntoView({
                behavior: "smooth"
            });
        } else {
            document.getElementById("main").scrollIntoView();
        }
    }

    checkScroll() {
        const pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight,
            document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        const offsetFromBottom = pageHeight - document.documentElement.offsetHeight - 200;
        const pageOffset = window.pageYOffset;
        this.setState({
            showButton: pageOffset > this.props.appearanceOffset && pageOffset < offsetFromBottom
        })
    }

    private boundScroll = throttle(this.checkScroll.bind(this), 50);

    componentWillUnmount() {
        window.removeEventListener('scroll', this.boundScroll.bind(this));
    }

    componentDidMount() {
        this.checkScroll();
        window.addEventListener('scroll', this.boundScroll);
    }

    render() {
        return (
            <ScrollToTopView {...this.props} {...this.state} scrollToTop={this.scrollToTop.bind(this)} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        appearanceOffset: state.calendarSettings.scrollToTopAppearanceOffset
    }
}

export default connect(mapStateToProps)(ScrollToTopBase);